// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__-YsFM","content":"styles_content__YELsP","checkbox":"styles_checkbox__3Ai_m","checkboxLabel":"styles_checkboxLabel__Zlouq"};